import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { makeStateKey, TransferState } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export const TOKENS_SSR_KEY = makeStateKey<any[]>('TOKENS_SSR_V1');
export const CHAIN_SSR_KEY = makeStateKey<number>('CHAIN_SSR_V1');

@Injectable({ providedIn: 'root' })
export class TokensResolver implements Resolve<any[]> {
  constructor(
    private http: HttpClient,
    private ts: TransferState
  ) { }

  resolve(): Observable<any[]> {
    // Si déjà présent (navigations client), renvoie direct
    const existing = this.ts.get(TOKENS_SSR_KEY, null as any);
    if (existing) return of(existing);

    // ⚠️ Si tu connais la chaîne côté SSR, remplace ici (ex: via config/env/SEO)
    const chainId = 1;

    const url = `${environment.backendUrl}/tokens/available`;
    return this.http.get<any[]>(url).pipe(
      map(list => Array.isArray(list) ? list : []),
      // (Recommandé) Réduire payload 1er paint: ne garder que la chaîne courante + top 20
      map(list =>
        list
          .filter(t => (t?.chainId ?? chainId) === chainId)
          .slice(0, 20)
      ),
      tap(tokens => {
        this.ts.set(TOKENS_SSR_KEY, tokens ?? []);
        this.ts.set(CHAIN_SSR_KEY, chainId);
      }),
      catchError(() => {
        this.ts.set(TOKENS_SSR_KEY, []);
        this.ts.set(CHAIN_SSR_KEY, chainId);
        return of([]);
      })
    );
  }
}
